module.exports = __webpack_public_path__ + "img/byqjc.c38a8ca9.png";